import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadDefensorResponseDto } from '@/api.types';
import { FilterDefensorDto } from '@/api.types.extra';

export async function EnumerateDefensores(
  skip: number,
  take: number,
  trazer_inativos: boolean = false,
  trazer_ativos: boolean = true,
  orderBy: string = "nome",
  orderbyasc: boolean = true,
  nome: string = '',
  cpf: string = ''
) {

  const filter: FilterDefensorDto = {
    skip: skip,
    take: take,
    orderBy: orderBy,
    orderbyasc: orderbyasc,
    nome,
    cpf
  }

  return api
    .get(Endpoints.DEFENSOR, { params: filter })
    .then((response) => {
      const res = GetApiReturn<ReadDefensorResponseDto>(response.data as Array<ReadDefensorResponseDto>);

      if (trazer_inativos === false)
        res.objects = res.objects.filter((a) => a.ativo);

      if (trazer_ativos === false)
        res.objects = res.objects.filter((a) => !a.ativo);

      return res;
    })
    .catch((error) => {
      ValidateAxiosError<ReadDefensorResponseDto>(error, 'Falha ao listar defensores.');
      return GetApiReturnError<ReadDefensorResponseDto>();
    });
}

export async function ReadDefensor(id: number) {
  return api
    .get(Endpoints.DEFENSOR, { params: { id, telefone: true, endereco: true } })
    .then((response) => {
      const res = GetApiReturn<ReadDefensorResponseDto>(response.data as Array<ReadDefensorResponseDto>);
      if (res.count > 0)
        return res.objects[0]
      return null
    })
    .catch((error) => {
      return ValidateAxiosError<ReadDefensorResponseDto>(
        error,
        'Falha ao buscar defensor.',
      );
    });
}